import { initWebVitals } from '@/plugins/webVitals';
import initMixpanel from '@/plugins/mixpanel';
import initGoogleAnalytics from '@/plugins/googleAnalytics';

const initAnalytics = (app) => {
  initMixpanel();
  initGoogleAnalytics();
  app.$registerMixpanelUser();
  initWebVitals(app);
};

export default initAnalytics;
